import Vue from "vue";
const templateId = +document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/firstfindblock.js";

let component = Vue.component("firstfindblock", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['jsonval', 'findVal'],
      mounted() {
        let x = window.location.href
        if (x.indexOf('findtext=') > 0) {
          this.urlValue = x
        }
        let inStockInput = document.querySelector('input[name=inStock]')
        if(inStockInput && +inStockInput.value>0){
          this.three = [1]
          this.isthreeLabel = true
        }
      },
      data() {
        return {
          templateId:templateId,
          one:'',
          mintwo:'',
          maxtwo:'',
          three:[],
          isSale:[],
          isoneLabel:false,
          istwoLabel:false,
          isthreeLabel:false,
          urlValue: ''
        }
      },
      computed:{
        labelclasstrue(){ return this.templateId>35 ? 'ok-form-label -state-active' : 'col-md-12 ok-label-static'},
        labelclassfalse(){ return this.templateId>35 ? 'ok-form-label' : 'col-md-12 ok-label-static -state-empty'},
      },
      watch: {
        mintwo() {
          if (this.mintwo==='' && this.maxtwo==='') {
            this.istwoLabel=false;
          } else {
            this.istwoLabel=true;}
        },
        maxtwo() {
          if (this.maxtwo==='' && this.mintwo==='') {
            this.istwoLabel=false;
          } else {
            this.istwoLabel=true;}
        },
        one() {
          if (this.one==='') {
            return this.isoneLabel=false;
          } else {
            this.isoneLabel=true;}
        },
        three() {
          if (this.three.length===0) {
            this.isthreeLabel=false
          } else {
            this.isthreeLabel=true;
          }
        },
        'urlValue': function() {
          if (this.urlValue.indexOf('findtext=') > 0) {
            if (this.findVal) {
              this.one = this.findVal
              this.isoneLabel = true
            }
            if (this.urlValue.indexOf('price_before_new') > 0) {
              let text_2 = this.urlValue.substring(this.urlValue.indexOf('price_before_new'))
              let first_2 = this.urlValue.substring(this.urlValue.indexOf('price_before_new')).indexOf('=')
              let last_2 = null
              if (this.urlValue.substring(this.urlValue.indexOf('price_before_new')).indexOf('&') === -1) {
                last_2 = this.urlValue.substring(this.urlValue.indexOf('price_before_new')).length
              } else {
                last_2 = this.urlValue.substring(this.urlValue.indexOf('price_before_new')).indexOf('&')
              }
              let res_2 = parseInt(text_2.substring(first_2 + 1, last_2))
              if (res_2) {
                this.mintwo = res_2
                this.istwoLabel = true
              }
            }
            if (this.urlValue.indexOf('price_after_new') > 0) {
              let text_3 = this.urlValue.substring(this.urlValue.indexOf('price_after_new'))
              let first_3 = this.urlValue.substring(this.urlValue.indexOf('price_after_new')).indexOf('=')
              let last_3 = null
              if (this.urlValue.substring(this.urlValue.indexOf('price_after_new')).indexOf('&') === -1) {
                last_3 = this.urlValue.substring(this.urlValue.indexOf('price_after_new')).length
              } else {
                last_3 = this.urlValue.substring(this.urlValue.indexOf('price_after_new')).indexOf('&')
              }
              let res_3 = parseInt(text_3.substring(first_3 + 1, last_3))
              if (res_3) {
                this.maxtwo = res_3
                this.istwoLabel = true
              }
              if (this.urlValue.indexOf('item_status=0') > 0) {
                this.three = [0]
                this.isthreeLabel = true
              }
            }
          }
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/firstfindblock.js